import { createFileRoute } from '@tanstack/react-router'

import { CustomersPage } from '@/features/dashboard/components/CustomersPage'

export const Route = createFileRoute('/_authed/customers')({ component: CustomersPage })
